export default class News {
    constructor() {
        this.$topics = document.getElementById("topics");
        this.$topicsList = this.$topics.querySelector(".topics__list");
        this.$news = document.getElementById("news");
        this.$newsTicker = this.$news.querySelector(".news__ticker");
        this.$newsIco = this.$news.querySelector(".c-ico.-arrow_r");

        this.currentMq = null;

        this.init();
    }

    init() {
        // JSON データを取得
        this.getJson();
    }

    getJson() {
        const xhr = new XMLHttpRequest(),
            json = "./assets/json/top/news.json";

        xhr.open("GET", json);
        xhr.send();
        xhr.addEventListener("load", () => {
            const data = JSON.parse(xhr.response);

            // ニュースのリスト要素を生成
            this.createList(data);
        });
    }

    createList(data) {
        this.$list = document.createElement("ul");

        // 最新ニュースから60日たったら非表示に
        const lastdata = data[0];
        this.hideNews(lastdata);

        data.forEach((obj) => {
            const style = !obj.url ? "pointer-events: none;" : "",
                href = obj.url ? obj.url : "#",
                date = obj.date
                    ? `<time datetime="${this.getDateTime(
                          obj.date
                      )}">${this.getZeroDate(obj.date)}</time>`
                    : "",
                category = obj.category ? `<span>${obj.category}</span>` : "",
                title = obj.title ? `<strong>${obj.title}</strong>` : "",
                icon = obj.url ? '<i class="c-ico -arrow_r"></i>' : "";
            this.$list.innerHTML += `<li>
                <a class="c-hover_op" style="${style}" href="${href}" target="_blank">
                    ${date}${category}${title}${icon}
                </a>
            </li>`;
        });

        // ニュースのリスト要素を追加
        this.appendList(this.$topicsList);

        // メディアクエリーの設定
        this.setCurrentMq();
        window.addEventListener("resize", () => this.setCurrentMq());
    }

    hideNews(lastdata) {
        const lastupdate = new Date(lastdata.date);
        const today = new Date();

        const after = 60;

        const todaydate = today.getTime();
        var enddate = lastupdate.getTime() + after * 24 * 60 * 60 * 1000;

        if (todaydate >= enddate) {
            document.body.classList.add("-hidenews");
        } else {
            document.body.classList.add("-shownews");
        }
    }

    getDateTime(ymd) {
        return ymd.replace(/\//g, "-");
    }

    getZeroDate(ymd) {
        const date = new Date(ymd),
            y = date.getFullYear(),
            m = `00${date.getMonth() + 1}`.slice(-2),
            d = `00${date.getDate()}`.slice(-2);

        return `${y}.${m}.${d}`;
    }

    appendList($target) {
        const $clone = this.$list.cloneNode(true);

        $target.appendChild($clone);
    }

    setCurrentMq() {
        const changeCurrentMq = (mq) => {
            this.$newsTicker.innerHTML = "";
            this.appendList(this.$newsTicker);
            this.currentMq = mq;

            // ニュースティッカーの設定
            setTimeout(() => this.setNewsTicker(), 500);
        };

        if (
            window.matchMedia("screen and (min-width: 769px)").matches &&
            this.currentMq != "wide"
        ) {
            changeCurrentMq("wide");
        } else if (
            window.matchMedia("screen and (max-width: 768px)").matches &&
            this.currentMq != "nrw"
        ) {
            changeCurrentMq("nrw");
        }
    }

    setNewsTicker() {
        const newsTickerWidth = this.$newsTicker.clientWidth,
            listWidth = this.$newsTicker.querySelector("ul").clientWidth;

        let totalWidth = 0;

        while (newsTickerWidth > totalWidth) {
            this.appendList(this.$newsTicker);
            totalWidth += listWidth;
        }

        // アニメーションの設定
        //this.setAnimation(listWidth);
    }

    setAnimation(listWidth) {
        const $listArray = [...this.$newsTicker.querySelectorAll("ul")],
            ratio = this.currentMq == "wide" ? 1 : window.innerWidth / 375,
            duration = (listWidth / (ratio * 50)) * 1000;

        $listArray.forEach(($list) => {
            const animation = $list.animate(
                [{ transform: "translateX(-100%)" }],
                { duration: duration, iterations: Infinity }
            );
            this.$newsIco.addEventListener(
                "mouseenter",
                () => (animation.playbackRate = 5)
            );
            this.$newsIco.addEventListener(
                "mouseleave",
                () => (animation.playbackRate = 1)
            );
        });
    }
}